import { render, staticRenderFns } from "./EditActMirror.vue?vue&type=template&id=17c504ac&scoped=true&"
import script from "./EditActMirror.vue?vue&type=script&lang=js&"
export * from "./EditActMirror.vue?vue&type=script&lang=js&"
import style0 from "./EditActMirror.vue?vue&type=style&index=0&id=17c504ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c504ac",
  null
  
)

export default component.exports